import * as React from "react";
import DetailGrid, { DetailGridItem } from "common/components/controls/DetailGrid";
import DetailGroup from "common/components/controls/DetailGroup";
import { formatDate } from "common/utils/FmtDate";
import { Prestup } from "common/api/Evidence/Clenove/Prestupy";
import PrestupyUtils from "common/utils/PrestupyUtils";

interface OdstupneProps {
    prestup: Prestup;
    je_to_puv_klub: boolean;
}

class Odstupne extends React.PureComponent<OdstupneProps>{

    render() {
        const { prestup, je_to_puv_klub } = this.props;

        if (je_to_puv_klub) {
            if (prestup.stav === PrestupyUtils.Stav_PotvrzeniOdst) return <OdstupneForm {...this.props} />;
            else return <OdstupneView {...this.props} />;
        } else {
            return prestup.stav > PrestupyUtils.Stav_PotvrzeniOdst ? <OdstupneView {...this.props} /> : null;
        }
    }
}

export default Odstupne;



class OdstupneView extends React.PureComponent<OdstupneProps>{

    render() {
        const { prestup, je_to_puv_klub } = this.props;
        const odstCastka = () => {
            if (prestup.odst_pozadovano) {
                return prestup.odst_castka + ",- Kč";
            }
            return prestup.odst_max_castka > 0 ? "není požadováno" : "nevzniká nárok na odstupné";
        };

        const odstDatZaplac = prestup.odst_zaplaceno ? formatDate(prestup.odst_dat_zaplac) : "nebylo zaplaceno";

        const items: DetailGridItem[] = [
            { label: 'Požadované odstupné', content: odstCastka() },
            { label: 'Zaplaceno dne', content: odstDatZaplac, show: prestup.odst_pozadovano },
        ];

        return (
            <DetailGroup title="Odstupné">
                <DetailGrid items={items} labelXS={4} />
                <OdstupnePotvrzeni {...this.props} />
                <DanovyDoklad {...this.props} />
            </DetailGroup>
        );
    }
}


class OdstupneForm extends React.PureComponent<OdstupneProps>{
    render() {
        return <div></div>
    }
}



class OdstupnePotvrzeni extends React.PureComponent<OdstupneProps>{
    render() {
        return <div></div>
    }
}


class DanovyDoklad extends React.PureComponent<OdstupneProps>{
    render() {
        return <div></div>
    }
}